/**
 * Copyright (C) IRT GmbH 2020
 */

/**
 * Removes brackets with episode information from titles like "Hubert und Staller (23)"
 *
 * @param {string} t
 * @returns {string}
 */
function stripEpisodeFromTitle(t) {
    try {
        return t.replace(/\s*\(([0-9]{1,5}|(S[0-9]{1,3}\/E[0-9]{1,4}))\)\s*$/g, "");
    } catch (e) {
        console && console.log(e);
    }
    return t;
}

/**
 * Create DOM Element and append as child to pElement.
 *
 * @param {Element} pElement
 * @param {string} nodeName
 * @param {string} className
 * @param {string} textContent
 *
 * @return {Element}
 */
function createElement(pElement, nodeName, className, textContent) {
    var elem = document.createElement(nodeName);
    if (typeof className == "string")
        elem.setAttribute("class", className);
    if (typeof textContent == "string")
        elem.innerHTML = textContent.replace('Dialog+', "<span class='dialogplus'>Dialog&#160;+</span>");

    return pElement.appendChild(elem);
}

/**
 * Creates a DOM Element representing a RC colour or number button.
 *
 * @param {Element} pElement
 * @param {*} btnLabel the number or empty string if a colour button
 * @param {*} colourClass class name to render button colour
 * @param {*} btnText the text next to button, i.e. the action executed by a button press.
 *
 * @returns {Element}
 */
function createButton(pElement, btnLabel, colourClass, btnText) {
    var button = createElement(pElement, "div", "button");
    var label = createElement(button, "div", "label " + colourClass, btnLabel);
    var text = createElement(button, "div", "text", btnText);
    return button;
}

module.exports = {
    stripEpisodeFromTitle : stripEpisodeFromTitle,
    createElement : createElement,
    createButton : createButton
};
